<template>
  <div class="home">
    <comHeader :activeIndex="'1'" />
    <div class="homemain">
      <img src="../images/index.png" alt="" />
    </div>
  </div>
</template>

<script>
import comHeader from "./comHeader.vue";

export default {
  name: "HomeView",
  components: {
    comHeader,
  },
};
</script>
<style lang="scss">
.homemain {
  width: 1700px;
  height: 1300px;
  margin: 20px auto;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
